import React from 'react';
import EventForm from './components/EventForm'
import { Modal } from 'reactstrap';

const AddEventPopup = ({rootProgram, program, isOpen, toggle, setTrigger}) => {
  const props = {
    rootProgram,
    program,
    toggle,
    setTrigger,
  };

  return (
    <Modal className="program-settings manager-program-settings-modal modal-xl" isOpen={isOpen} toggle={toggle}>
      <div className="manager-program-settings-modal__layout">
        <div className="manager-program-settings-modal__main">
          <div className="manager-program-settings-modal__header">
            <div className="manager-program-settings-modal__header-copy">
              <h3 className="manager-program-settings-modal__title">Add New Event</h3>
              <p className="manager-program-settings-modal__subtitle">
                Create and configure a reward event.
              </p>
            </div>
            <button
              type="button"
              className="manager-program-settings-modal__close"
              onClick={toggle}
              aria-label="Close"
            >
              Close
            </button>
          </div>
          <div className="manager-program-settings-modal__body">
            <EventForm {...props} />
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default AddEventPopup;
